<template>
  <section class="ws-file-download" style="display:none;">
      <p class="ws-file-download-description">{{ $t('Файл задания:') }}</p>
      <div class="ws-file-download-links">
        <!-- <a class="ws-file-download-link" @click="openFile">{{ $t('Открыть') }}</a>-->
        <a :disabled="disabled" class="ws-button button is-fullwidth is-primary ws-file-download-link" @click.stop="openFile({ download:true })">
          <span class="is-size-5">
            {{ $t('Скачать файл задания') }}
            <span class="has-text-weight-bold">{{ file.file_name }}</span> ({{ prettyBytes(file.file_size) }})
          </span>
          <ws-spinner v-if="isOpeningFile" />
        </a>
      </div>
  </section>
</template>

<script>
import saveAs from 'file-saver'
import prettyBytes from '@/filters/prettyBytes'
import { mapActions } from 'vuex'
export default {
  name: 'WsFileDownload',
  props: {
    file: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isOpeningFile: false
    }
  },
  methods: {
    ...mapActions('profile/files', {
      getFileById: 'getFileById'
    }),
    prettyBytes,
    async openFile (options) {
      if (this.disabled) return
      this.isOpeningFile = true
      try {
        const file = await this.getFileById({
          'file-guid': this.file.guid
        })
        if (file && file.redirect_to) {
          if (options && options.download) {
            const _file = await fetch(`${file.redirect_to}`, { method: 'get' })
            saveAs(await _file.blob(), this.file.file_name)
          } else {
            window.location.href = file.redirect_to
          }
        }
      } catch (e) {
        // console.log(e)
      }
      this.isOpeningFile = false
    }
  }
}
</script>
